export default "__VITE_ASSET__59$YQ7ee__"